import React from "react";
import "../components/Contactanos.css";
import trabaja from "../assets/img/trabajav2.jpg";
import FormularioWeb from "../components/FormularioWeb";
import Footer from "../components/Footer";

const Contactanos = () => {
  return (
    <div>
      <div className="bannerContactanos">
        <h1 className="bannerContactanos-title">Contáctanos</h1>
      </div>
      <div className="containerBannerContactanos">
        <p className="textoBannerContactanos">
          Respondemos rápidamente a tus requerimientos. Ponte en contacto con
          nosotros.
        </p>
      </div>
      {/* ----RABAJA CON NOSOTROS----- */}
      <div className="containerTrabaja">
        <div className="contentTrabaja">
          <h1>Trabaja con nosotros</h1>

          <p>
            Trabaja con nosotros Buscamos el mejor talento que esté dispuesto a
            asumir desafíos con espíritu innovador y calidad de servicio.
            Contamos con ofertas de trabajo competitivas, un ambiente motivador
            y una estructura laboral sólida para tu desarrollo profesional.
          </p>
          <p>
            Somos una empresa dinámica con altos estándares éticos, enfocados en
            responder a nuestros clientes con proactividad y eficiencia.
            Buscamos las mejores personas que quieran ser parte de este equipo
            de primer nivel.
          </p>
          <p>
          Primus Capital es una empresa que apoya la inclusión y la diversidad. Nuestra cultura es de integración y respeto a las diferencias.
          </p>
          <p>
            Si quieres vivir la experiencia de pertenecer a una compañía
            ampliamente valorada en el sector financiero, envíanos tu hoja de vida al correo<span> </span>
            <a href="mailto:trabajo@primuscapital.pe" className="emailTrabaja">
              trabajo@primuscapital.pe
            </a>
            para que estés en nuestra base de datos.
          </p>
        </div>
        <div className="image-containerTrabaja">
          <img src={trabaja} alt="Imagen" />
        </div>
      </div>
      <div className="formulario">
        <h2>¿Tienes facturas pendientes de cobro?</h2>
        <FormularioWeb />
      </div>
      <Footer />
    </div>
  );
};

export default Contactanos;
